import PropTypes from 'prop-types';
import React from 'react';
import { H3 } from '../../../style/Typography';
import { Naked as NakedButton } from '../../Buttons/Button';
import { TypographyWeight } from '../../../style/Typography/consts';
import * as S from './styled';

export const LabelAndClear = ({ label, onClear, clearLabel }) => (
  <S.FilterControlHeader>
    <H3 weight={TypographyWeight.SEMI_BOLD}>{label}</H3>
    <S.ClearButtonWrapper $hidden={!onClear}>
      <NakedButton onClick={onClear}>{clearLabel || 'Clear'}</NakedButton>
    </S.ClearButtonWrapper>
  </S.FilterControlHeader>
);

LabelAndClear.propTypes = {
  label: PropTypes.node,
  clearLabel: PropTypes.node,
  onClear: PropTypes.func
};
